export const KEY_DEV_CATEGORY_LABELS: Record<string, string> = {
  C2: 'Transactions',
  C1: 'Forecasts & Ratings',
  C3: 'Potential Transactions',
  C4: 'Listing/Trading',
  C5: 'Red Flags',
  C6: 'Results & Comms',
  C7: 'Customer/Product',
  C8: 'Corporate Structure',
  C10: 'Dividends/Splits',
  C12: 'Bankruptcy',
  C13: 'Activism',
  C15: 'Transaction Updates',
};

export const ALL_CATEGORIES = Object.keys(KEY_DEV_CATEGORY_LABELS);

export const DEFAULT_CATEGORIES = ['C2'];
